import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Row, Message } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import CheckboxRowForm from '../../components/forms/checkboxRowForm/CheckboxRowForm'
import EditButton from '../../components/buttons/editButton/EditButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { getRequiredData } from '../../utils/ValidatorUtils'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import { saveStrategic, saveStrategicPercent } from '../../redux/actions/strategic'
import scrollToComponent from 'react-scroll-to-component'
import CheckboxRowHaveSubForm from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubForm'
import CheckboxRowHaveSubView from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubView'

import AlertWidget from '../confirm/AlertWidget'

export default function Strategic({ schema, projectVersionId, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit, onComplete, isReview } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [formSchema, setFormSchema] = useState(schema)
  const [percentError, setPercentError] = useState()
  const [isSavePercentageSuccess, setIsSavePercentageSuccess] = useState(false)

  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveStategic = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const _schema = await saveStrategic(request)
      if (_schema.model?.forms?.ProjectStrategy) {
        setFormSchema(_schema.model.forms.ProjectStrategy)
      }
      onChangeIsEdit(false)
      if (typeof onComplete === 'function') {
        onComplete()
      }
      await dispatch(getSchemaSidebar(projectId))
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSaveStategicPercent = async (request) => {
    startLoading()
    setIsSavePercentageSuccess(false)
    setIsLoading(true)
    setIsError(false)
    try {
      const _schema = await saveStrategicPercent(request)
      if (_schema.model?.forms?.ProjectStrategy) {
        setFormSchema(_schema.model.forms.ProjectStrategy)
      }
      onChangeIsEdit(false)
      setIsSavePercentageSuccess(true)
      if (typeof onComplete === 'function') {
        onComplete()
      }
      await dispatch(getSchemaSidebar(projectId))
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let optionSelected = data.selectedList.map((item) => {
      return { value: item, selected: true }
    })

    let reqestData = {
      projectVersionId: projectVersionId || projectId,
      options: optionSelected,
      year: formSchema.bugetYear,
      version: formSchema.version,
    }
    // console.log('reqestData : ', JSON.stringify(reqestData))
    handleSaveStategic(reqestData)
  }

  const onSubmitPercent = (data) => {
    console.log('onSubmit', data)
    setPercentError()

    let datas = []
    let totalPercent = 0

    for (const [key, value] of Object.entries(data)) {
      totalPercent += value

      datas.push({
        id: key.replace('percentage_', ''),
        value: value,
      })
    }

    if (totalPercent <= 100) {
      let reqestData = {
        projectVersionId: projectVersionId || projectId,
        datas: datas,
      }
      // console.log('reqestData : ', JSON.stringify(reqestData))
      handleSaveStategicPercent(reqestData)
    } else {
      setPercentError('ระบุสัดส่วนได้ไม่เกิน 100 สัดส่วนปัจจุบันคือ ' + totalPercent)
    }
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header || formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit ? (
          // <CheckboxRowForm
          <CheckboxRowHaveSubForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <CheckboxRowHaveSubView
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            isInput={isReview}
            inputKey="percentage_"
          />
        )}

        {showCommandButton && (
          <>
            {!isEdit && (
              <Message showIcon type="warning" description={'*กรุณาระบุเป็นจำนวนร้อยละ'} />
            )}
            <hr />
            {isEdit ? (
              <>
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}
                <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                  บันทึก{projectVersionId ? 'ยุทธศาสตร์' : formSchema.header || formSchema.title}
                </SaveButton>
                <CancelButton onClick={() => onChangeIsEdit(false)} disabled={isLoading}>
                  ยกเลิกการแก้ไข
                  {projectVersionId ? 'ยุทธศาสตร์' : formSchema.header || formSchema.title}
                </CancelButton>
              </>
            ) : (
              <>
                {isReview && (
                  <>
                    {isError && (
                      <Row style={{ marginBottom: 10 }}>
                        <Message
                          showIcon
                          type="error"
                          description={
                            'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                          }
                        />
                      </Row>
                    )}
                    {percentError && (
                      <Row style={{ marginBottom: 10 }}>
                        <Message showIcon type="error" description={percentError} />
                      </Row>
                    )}
                  </>
                )}
                <EditButton
                  onClick={(e) => {
                    onChangeIsEdit(true)
                    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                  }}
                  disabled={isLoading}
                >
                  แก้ไข{projectVersionId ? 'ยุทธศาสตร์' : formSchema.header || formSchema.title}
                </EditButton>
                {isReview && (
                  <SaveButton onClick={handleSubmit(onSubmitPercent)} disabled={isLoading}>
                    บันทึกสัดส่วน
                    {projectVersionId ? 'ยุทธศาสตร์' : formSchema.header || formSchema.title}
                  </SaveButton>
                )}
              </>
            )}
          </>
        )}
      </Panel>

      <AlertWidget
        title={'แจ้งเตือน'}
        show={isSavePercentageSuccess}
        detail={`บันทึกสำเร็จ`}
        onClose={() => {
          setIsSavePercentageSuccess(false)
        }}
      />
    </>
  )
}
